import React from "react";
import "./Header.css";
import Search from "@mui/icons-material/Search";
import ShoppingBasket from "@mui/icons-material/ShoppingBasket";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { itemsInCartSelector } from "../../Reducers/AddToCartReducer";
import {
  getUserDetailsSelector,
  getUserNameSelector,
} from "../../Reducers/AuthenticationReducer";
import { auth } from "../../firebase";

function Header({ itemsInCart, userDetails, userNameFromEmail }) {
  const handleAuthentication = () => {
    if (userDetails) auth.signOut();
  };

  return (
    <div className="header">
      <Link to="/">
        <img
          src="https://pngimg.com/uploads/amazon/amazon_PNG11.png"
          width="50px"
          alt="amazon logo"
          className="header__logo"
        />
      </Link>
      <div className="header__search">
        <input type="text" className="header__searchInput" />
        <Search className="header__searchIcon" />
      </div>

      <div className="header__nav">
        <Link to={!userDetails && "/login"}>
          <div className="header__option" onClick={handleAuthentication}>
            <span className="header__optionLineOne">
              Hello, {userNameFromEmail || "Guest"}
            </span>
            <span className="header__optionLineTwo">
              {userDetails ? "Sign out" : "Sign in"}
            </span>
          </div>
        </Link>
        <Link to="/orders">
          <div className="header__option">
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </Link>
        <div className="header__option">
          <span className="header__optionLineOne">Your</span>
          <span className="header__optionLineTwo">Prime</span>
        </div>
        <Link to="/checkout">
          <div className="header__optionBasket">
            <ShoppingBasket />
            <span className="header__optionLineTwo header__basketCount">
              {itemsInCart}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    itemsInCart: itemsInCartSelector(state),
    userDetails: getUserDetailsSelector(state),
    userNameFromEmail: getUserNameSelector(state),
  }),
  null
)(Header);
